module.exports = __webpack_public_path__ + "images/init/reports-empty-010ca010df30099aadf7a514d3c80c7e.png";